import React from 'react';

import { Icon, IconProps } from '@chakra-ui/icons';

export const RepublicSeedrsColorLogoIcon = (props: IconProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="352px"
    height="60px"
    viewBox="0 0 352 60"
    {...props}
  >
    <path
      fill="#20292E"
      fillRule="evenodd"
      d="M215.669 4.597v6.98c-2.208-1.559-4.19-2.34-5.956-2.34-1.906 0-3.459.667-4.668 1.995q-1.81 1.896-1.81 5.051 0 2.787 1.288 4.78.659 1.064 2.179 2.748 1.512 1.685 3.915 4.058 4.426 4.432 6.024 7.665c1.068 2.086 1.597 4.637 1.597 7.666 0 4.101-1.165 7.483-3.506 10.139-2.351 2.588-5.357 3.886-9.022 3.886q-4.632 0-7.907-2.513v-7.079q3.864 2.785 7.035 2.785c1.975 0 3.514-.65 4.628-1.941 1.119-1.294 1.677-3.056 1.677-5.277 0-1.923-.433-3.656-1.29-5.19-.445-.734-1.057-1.58-1.852-2.53q-1.181-1.424-2.956-3.179c-1.832-1.786-3.355-3.368-4.56-4.742q-1.812-2.063-2.682-3.612-1.672-3.02-1.671-7.627c0-4.148 1.088-7.438 3.274-9.867 2.207-2.452 5.159-3.677 8.879-3.677q3.865 0 7.384 1.82M222.616 3.496h19.256v6.052h-12.014v16.808h10.656v6.051h-10.656V50.52h12.014v6.047h-19.256zM247.233 3.496h19.257v6.052h-12.016v16.808h10.659v6.051h-10.659V50.52h12.016v6.047h-19.257zM278.445 50.315q6.613 0 8.847-3.955 2.298-3.952 2.298-15.364c0-8.182-.734-13.81-2.192-16.879q-2.196-4.602-8.046-4.603h-.907zm-7.244-46.82h8.916c2.716 0 5.003.302 6.865.895q2.57.86 4.592 3.06c2.021 2.2 3.459 5.066 4.322 8.593q1.286 5.121 1.286 14.679 0 8.766-1.43 14.298c-.925 3.53-2.461 6.221-4.594 8.078q-3.94 3.468-14.101 3.468h-5.856zM310.124 27.01c2.809 0 4.798-.641 5.957-1.925q1.74-1.925 1.741-6.5c0-1.648-.12-3.055-.369-4.23-.242-1.164-.627-2.115-1.147-2.848a4.62 4.62 0 0 0-2.019-1.617q-1.237-.513-2.944-.513h-1.219zm-7.243-23.514h9.541q5.917.001 8.811 2.785 3.658 3.61 3.658 11.033-.002 5.71-1.932 9.163-1.935 3.454-5.519 4.276l9.889 25.813h-7.349l-9.856-25.983v25.983h-7.243zM349.147 4.597v6.98q-3.309-2.34-5.955-2.34-2.856.002-4.669 1.995-1.81 1.896-1.81 5.051.001 2.787 1.289 4.78.66 1.064 2.174 2.748c1.007 1.122 2.32 2.477 3.921 4.058q4.423 4.432 6.024 7.665c1.065 2.086 1.603 4.637 1.603 7.666 0 4.101-1.176 7.483-3.515 10.139-2.346 2.588-5.357 3.886-9.025 3.886q-4.63 0-7.903-2.513v-7.079q3.868 2.785 7.033 2.785c1.976 0 3.519-.65 4.638-1.941 1.11-1.294 1.666-3.056 1.666-5.277 0-1.923-.43-3.656-1.287-5.19q-.664-1.103-1.845-2.53a46 46 0 0 0-2.963-3.179q-2.75-2.68-4.56-4.742-1.812-2.063-2.682-3.612-1.672-3.02-1.674-7.627c0-4.148 1.094-7.438 3.273-9.867 2.208-2.452 5.167-3.677 8.885-3.677q3.861 0 7.382 1.82"
      clipRule="evenodd"
    />
    <path
      fill="#BCD672"
      fillRule="evenodd"
      d="M126.72 22c7.856-7.75 40.246-12.872 43-13.297-11.879-11.63-31.063-11.606-42.903.084-10.775 10.636-11.738 27.248-2.959 38.993A20.534 20.534 0 0 1 126.72 22"
      clipRule="evenodd"
    />
    <path
      fill="#6B8F3E"
      fillRule="evenodd"
      d="M169.897 8.877c-.429 2.718-5.615 34.695-13.468 42.445-7.098 7.007-18.004 7.936-26.131 2.821 11.901 8.672 28.738 7.725 39.515-2.913a29.73 29.73 0 0 0 .084-42.353"
      clipRule="evenodd"
    />
    <path
      fill="#8AC144"
      fillRule="evenodd"
      d="M160.2 41.912c-6.329 6.248-16.814 6.02-23.428-.51-6.613-6.524-6.844-16.877-.517-23.124 1.479-1.459 4.122-2.77 7.296-3.922-7.185 2.086-13.818 4.67-16.831 7.644a20.55 20.55 0 0 0 0 29.322c8.205 8.098 21.505 8.098 29.709 0 3.012-2.972 5.628-9.511 7.739-16.595-1.165 3.124-2.49 5.727-3.968 7.185"
      clipRule="evenodd"
    />
    <path
      fill="#DFE3E8"
      fillRule="evenodd"
      d="M84.828 60V0h2.069v60z"
      clipRule="evenodd"
    />
    <path
      fill="#157EFF"
      fillRule="evenodd"
      d="M35.531 35.495 53.701 60H0V0h28.238c.978 0 1.872.038 2.696.111 9.4.733 16.8 8.59 16.8 18.176 0 7.954-5.096 14.718-12.203 17.208"
      clipRule="evenodd"
    />
    <path
      fill="#157EFF"
      fillRule="evenodd"
      d="M34.973 60H0V0l53.328 60z"
      clipRule="evenodd"
    />
    <path
      fill="#00BDFF"
      fillRule="evenodd"
      d="M53.7 60H.004l26.661-41.9z"
      clipRule="evenodd"
    />
    <path
      fill="#1560FA"
      fillRule="evenodd"
      d="M0 34.72V0h14.987L37.38 34.717z"
      clipRule="evenodd"
    />
    <path
      fill="#00EFE9"
      fillRule="evenodd"
      d="M16.089 34.726 26.664 18.1l10.724 16.626z"
      clipRule="evenodd"
    />
    <path
      fill="#157EFF"
      fillOpacity=".5"
      fillRule="evenodd"
      d="M53.7 60H33.75l-7.086-41.9z"
      clipRule="evenodd"
    />
  </Icon>
);
